export const Alerts = (props) => {
const {title, id, error = false} = props;



    return (
        <div id={id} className='content-alerts'>
            <div className='alert-actions flex items-center'>
                <img style={{width: '7%', height: '7%'}} src={error ? '/icons/alert-triangle-yellow.svg' : '/icons/good-notificaction-icon.svg'} alt='' />
                <span>{title}</span>
            </div>
        </div>
    )
}

